// AboutSigmaStudio.jsx
import React, { useState } from 'react';
import MainLayout from '../../layouts/MainLayout';
import '../../styles/Think5WhysHelp.css';

const AboutApplauseHub = () => {
  const topics = [
    {
      title: 'Think5Whys Applause Hub',
      description: (
        <div>
          <p>The Think5Whys Applause Hub is a dedicated platform designed to celebrate achievements, 
          foster recognition, and promote collaboration within our community. Through a suite of features 
          tailored to individual and collective accomplishments, the Applause Hub aims to cultivate a culture of 
          appreciation and encouragement.
          </p>
          <br/>
          <p>Users can utilize the Self Applause feature to privately acknowledge their own successes, 
          while also receiving applause from peers through the Applause For Me section. 
          Additionally, the I Applauded feature enables users to track their engagement and contributions to others.
          </p>
          <br/>
          <p>With My Applause Badges, users can access and display earned badges symbolizing various achievements 
          and milestones, while My Applause Certificate allows retrieval and display of certificates 
          for outstanding performances. The My Applause Trophy serves as a virtual trophy for 
          exceptional accomplishments and consistent positive engagement.
          </p>
          <br/>
          <p>Through features like My Applause Hub Credits and Transfer Applause Hub Credits, 
          users can manage and transfer earned credits, fostering collaboration and shared recognition. 
          The Applause Leaderboard showcases top contributors, and My Applause Settings enable users to customize their experience.
          </p>
          <br/>
          <p>Overall, the Applause Hub serves as a central hub for celebrating achievements, encouraging collaboration, 
          and enhancing user engagement within the Think5Whys community, creating a positive and 
          supportive environment for all members.
          </p>
        </div>
      ),
    },
    {
      title: '1. Self Applause',
      description: (
        <div>
          <p>Recognize and appreciate your own achievements using the Self Applause feature. Celebrate your successes and accomplishments privately.</p>
        </div>
      ),
    },
    {
      title: '2. Applause For Me',
      description: (
        <div>
          <p>View and collect applause received from others for your contributions and achievements. This section showcases recognition from your peers.</p>
        </div>
      ),
    },
    {
      title: '3. I Applauded',
      description: (
        <div>
          <p>Keep track of the applause you've given to others. Monitor your engagement and encouragement provided to fellow users.</p>
        </div>
      ),
    },
    {
      title: '4. My Applause Badges',
      description: (
        <div>
          <p>Access and showcase the badges you've earned through the Applause Hub. Badges signify various achievements and milestones in your journey.</p>
        </div>
      ),
    },
    {
      title: '5. My Applause Certificate',
      description: (
        <div>
          <p>Retrieve and display certificates awarded for outstanding performances and contributions acknowledged through the Applause Hub.</p>
        </div>
      ),
    },
    {
      title: '6. My Applause Trophy',
      description: (
        <div>
          <p>Showcase the virtual trophy awarded for exceptional accomplishments and consistent positive engagement within the Think5Whys community.</p>
        </div>
      ),
    },
    {
      title: '7. My Applause Hub Credits',
      description: (
        <div>
          <p>Manage and track your earned credits within the Applause Hub. Credits can be used for various activities and transactions on the platform.</p>
        </div>
      ),
    },
    {
      title: '8. Transfer Applause Hub Credits',
      description: (
        <div>
          <p>Transfer your earned Applause Hub credits to other users, fostering a spirit of collaboration and shared recognition.</p>
        </div>
      ),
    },
    {
      title: '9. Applause Leaderboard',
      description: (
        <div>
          <p>Explore the leaderboard to see who's leading in terms of applause and recognition. Celebrate the community's top contributors.</p>
        </div>
      ),
    },
    {
      title: '10. My Applause Settings',
      description: (
        <div>
          <p>Customize and manage your settings related to the Applause Hub. Tailor your preferences for a personalized experience.</p>
        </div>
      ),
    },
  ];

  const [expandedTopic, setExpandedTopic] = useState(null);

  const handleTopicClick = (index) => {
    setExpandedTopic(expandedTopic === index ? null : index);
  };

  return (
    <MainLayout>
      <div className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>
        <h2>About Think5Whys ApplauseHub</h2>
      </div>
      <div className="help-container">
        <ul className="help-list">
          {topics.map((topic, index) => (
            <li key={index} onClick={() => handleTopicClick(index)} className="help-topic">
              {topic.title}
              {expandedTopic === index && (
                <div className="help-description">
                  <p>{topic.description}</p>
                </div>
              )}
            </li>
          ))}
        </ul>
      </div>
    </MainLayout>
  );
};

export default AboutApplauseHub;

